// Always render a two-digit day and month so dates stay visually consistent
// across locales (German `22.05.2024`, not `22.5.2024`).
const DATE_OPTIONS = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric"
};
function formatLocaleDate(date, fallback = "-") {
    if (!date) {
        return fallback;
    }
    const { lang } = document.documentElement;
    return new Date(date).toLocaleDateString(lang, DATE_OPTIONS);
}
function formatLocaleDateTime(date, fallback = "-") {
    if (!date) {
        return fallback;
    }
    const { lang } = document.documentElement;
    return new Date(date).toLocaleString(lang, {
        ...DATE_OPTIONS,
        hour: "2-digit",
        minute: "2-digit"
    });
}
export { formatLocaleDate, formatLocaleDateTime };
